import api from './api';
import { AuthResponse, LoginCredentials, RegisterData, Usuario } from '../types';

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/login', credentials);
    const { token, usuario } = response.data;
    
    // Store in localStorage
    localStorage.setItem('token', token);
    localStorage.setItem('usuario', JSON.stringify(usuario));
    
    return response.data;
  },

  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/registrar', {
      nome: data.nome,
      email: data.email,
      senha: data.senha,
      telefone: data.telefone,
      tipo: data.tipo,
    });
    
    const { token, usuario } = response.data;
    
    // Store in localStorage
    localStorage.setItem('token', token);
    localStorage.setItem('usuario', JSON.stringify(usuario));
    
    return response.data;
  },

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      // Ignore errors on logout
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
    }
  },

  async getProfile(): Promise<Usuario> {
    const response = await api.get<Usuario>('/auth/perfil');
    localStorage.setItem('usuario', JSON.stringify(response.data));
    return response.data;
  },

  async updateProfile(data: Partial<Usuario>): Promise<Usuario> {
    const response = await api.put<Usuario>('/auth/perfil', data);
    localStorage.setItem('usuario', JSON.stringify(response.data));
    return response.data;
  },

  async changePassword(senhaAtual: string, novaSenha: string): Promise<void> {
    await api.put('/auth/senha', { senhaAtual, novaSenha });
  },

  async forgotPassword(email: string): Promise<void> {
    await api.post('/auth/esqueci-senha', { email });
  },

  async resetPassword(token: string, novaSenha: string): Promise<void> {
    await api.post('/auth/resetar-senha', { token, novaSenha });
  },

  async verifyEmail(token: string): Promise<void> {
    await api.post('/auth/verificar-email', { token });
  },

  async resendVerification(): Promise<void> {
    await api.post('/auth/reenviar-verificacao');
  },

  getStoredUser(): Usuario | null {
    const stored = localStorage.getItem('usuario');
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch {
        return null;
      }
    }
    return null;
  },

  getToken(): string | null {
    return localStorage.getItem('token');
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },

  isAdmin(): boolean {
    const user = this.getStoredUser();
    return user?.tipo === 'admin';
  },
};

export default authService;
